//Junais 08-Dec-2022
import React from 'react'
import { useDispatch, useSelector } from "react-redux";
import CustomModal from './CustomModal';
import * as appActions from '../actions/appactions'
import * as userActions from '../modules/userprofile/actions/userprofileactions'
import * as appConstants from '../overrides/appconstants'

export default function AppMessage() {
    const appReducerState = useSelector((state) => state.appReducer);

    const dispatch = useDispatch();
    
    function onButtonClick(button) {
        dispatch(appActions.closeMessage());
        appReducerState.messageCallback(button);

    }
    
    function renderButtons() {
        let buttons = [];
        if (appReducerState.messageOptions != undefined && appReducerState.messageOptions.buttons != undefined) {
            buttons = appReducerState.messageOptions.buttons;
        } else {
            buttons.push('OK');
        }
        return buttons.map(buttonText => {
            return (
                
                    <button className={buttonText==="Close" ? 'btn btn-danger': 'btn btn-success'} style={{marginLeft: '10px'}} key={buttonText} onClick={() => onButtonClick(buttonText)}>
                        { buttonText==="Close"  ? <i className="dripicons-cross"></i> : <i className="dripicons-checkmark"></i>} {buttonText}
                        </button>
                
            );
        });
    }
    let hasMessage = appReducerState.message != '';
    
   

    return (

        <CustomModal
            isOpen={hasMessage} zIndex="100000000">
            <div class="modal-body">
                <div >
                        <strong> {appReducerState.message}</strong>
                    </div>
            </div>
            <div class="modal-footer">
                {renderButtons()}
            </div>
        </CustomModal>
    )

}

